/* centralized text constants for the portfolio */

export const TEXT = {
  // about window content
  ABOUT: {
    TITLE: "About Avo",
    CONTENT: {
      GREETING: "Hi, I'm Avo!",
      IMAGE: "/assets/me.png",
      DESCRIPTION: "I'm a fourth-year Computer Science w/ Business Applications student at UC Riverside, a full-time Software Engineer Intern at Visa, and a first-generation Armenian-American.",
      BIO: "I'm always looking for opportunities in software engineering and/or project management. My passion lies in building and shipping products with real-world impact and a positive user experience.",
      BIO2: "Thank you so much for visiting my portfolio!",
      TRIVIA: {
        TITLE: "Trivia",
        QUESTIONS: [
          { question: "Favorite Programming Language", answer: "Python" },
          { question: "Favorite TV Show", answer: "The Sopranos" },
          { question: "Favorite Video Game", answer: "Anything Zelda" },
          { question: "Favorite Sport", answer: "MMA" },
          { question: "Favorite Dessert", answer: "Tiramisu" }, 
        ]
      },
      LINKS: {
        GITHUB: "GitHub",
        LINKEDIN: "LinkedIn"
      },
      EMAIL: "Email: avokaramusyan@gmail.com"
    }
  },

  // window titles
  WINDOW_TITLES: {
    ABOUT: 'About Avo - Personal.exe',
    SKILLS: 'Resume - Adobe Reader',
    REPOSITORIES: 'Code Vault - Repository Manager',
    ENVIRONMENTS: '3D Gallery - Model Viewer',
    EMAIL: 'Contact Me - Address Book',
    PROJECTS: 'My Creations - Project Explorer',
    EXPERIENCE: 'Work History - Career Tracker',
    EDUCATION: 'Academic Records - Transcript Viewer',
    PROJECT_DETAIL: (title) => `${title} - Project Details`,
    EXPERIENCE_DETAIL: (title) => `${title} - Experience Details`,
    PROJECT_DETAIL_FALLBACK: 'Project Details - Info Panel',
    EXPERIENCE_DETAIL_FALLBACK: 'Experience Details - Info Panel'
  },

  // taskbar
  TASKBAR: {
    START: "Start",
    CLOSE_ALL: "Close All",
    TIME_DROPDOWN: "It's time to hire me!!!"
  },

  // projects data
  PROJECTS: {
    ROUNDEX: {
      NAME: 'Roundex',
      DATE: '05/25 - Present',
      TYPE: 'Health-Tech Mobile App',
      TITLE: 'Roundex - Health-Tech Mobile App',
      SUBTITLE: '',
      IMAGE: '',
      SECTIONS: [
        {
          title: 'Project Description',
          content: [
            { text: 'Roundex is a health-tech <strong>SaaS</strong> platform designed for behavioral rehabilitation centers. It is currently a functional (MVP) <strong>Flutter</strong> application for <strong>iOS</strong> and <strong>Android</strong> devices. After more UX testing at rehabs, my intention is to turn it into a startup. Due to ongoing business development, only a limited description of its core functionality can be shared publicly at this time.', type: '' }
          ]
        },
        {
          title: 'Features',
          content: [
            { text: '• <strong>Dart</strong> frontend', type: '' },
            { text: '• Cross-platform capability thanks to <strong>Flutter</strong>', type: '' },
            { text: '• <strong>Firebase Auth</strong> with admin/user access codes and role-based control', type: '' },
            { text: '• <strong>Firebase Cloud Functions</strong> for a secure serverless backend', type: '' },
            { text: '• <strong>Cloud Firestore</strong> for real-time updates and optimally structured data storage for my use case. Also helps with offline persistence because of Firestore\'s cache', type: '' },
            { text: '• <strong>Github Actions</strong> workflow with <strong>AI</strong> code review solely to identify if/when refactoring is needed', type: '' },
            { text: '• NOT vibe coded', type: '' }
          ]
        },
        {
          title: 'Gallery',
          content: [
            { 
              type: 'video',
              src: process.env.PUBLIC_URL + '/assets/roundexDemo.mp4',
              caption: 'Brief demo of the VERY first version of Roundex in May 2025. I have come a very long way since then but must keep anything beyond the super simple CRUD functionality in this video totally confiential for now. This is just to give you a gist.'
            }
          ]
        }
      ]
    },
    SPELLCASTER: {
      NAME: 'Spellcaster',
      DATE: '11/25 - 11/25',
      TYPE: 'Hackathon-Winning Game',
      TITLE: 'Spellcaster | 1st Place Winner, CutieHack 2025',
      SUBTITLE: 'November 2025 - November 2025',
      IMAGE: '',
      SECTIONS: [
        {
          title: 'Project Description',
          content: [
            { text: 'Spellcaster is a competitive 1v1 multiplayer game where two players race to spell complex spell names quickly and accurately. The project was built during a 12-hour hackathon sprint with a strong focus on gameplay clarity, responsiveness, and polished UI/UX.', type: '' }
          ]
        },
        {
          title: 'Contribution Summary',
          content: [
            { text: '• Designed a 1v1 multiplayer game in 12 hours using <strong>React</strong>, <strong>TypeScript</strong>, <strong>Express.js</strong>, and <strong>Socket.IO</strong>.', type: '' },
            { text: '• Achieved 1st place out of 200+ hackathon participants, recognized for exceptional UI/UX and technical depth.', type: '' }
          ]
        },
        {
          title: 'Links',
          content: [
            { text: '• <a href="https://devpost.com/software/spellcaster-ou5abn?_gl=1*fxd33i*_gcl_au*MTcyMTg0NDk0MS4xNzgwNjc3MzY3*_ga*NjM1ODk0OTY0LjE3Njg0MzY4OTk.*_ga_0YHJK3Y10M*czE3ODA2NzczNjckbzIkZzEkdDE3ODA2NzczODYkajQxJGwwJGgw" target="_blank" rel="noopener noreferrer">Devpost Submission</a>', type: '' },
            { text: '• <a href="https://github.com/akaFM/spellcaster" target="_blank" rel="noopener noreferrer">GitHub Repository</a>', type: '' }
          ]
        }
      ]
    },
    FINORIA: {
      NAME: 'Finoria',
      DATE: '06/24 - 12/24',
      TYPE: 'Financial Analytics Site',
      TITLE: 'Finoria - Full Stack Financial Analysis Web App',
      SUBTITLE: '',
      IMAGE: '',
      SECTIONS: [
        {
          title: 'Project Description',
          content: [
            { text: 'Finoria is a full-stack web app dedicated to being a "financial assistant" for stock market beginners. It is a space where users can explore stocks by defining preferences, viewing detailed daily metrics, generating <strong>AI</strong> summaries, and reading the sentiment of market experts. I used it as a learning experience to bridge my knowledge from coursework to real-world application.', type: '' },
            { text: 'I took the site down because I did not want to keep paying for hosting costs.', type: '' }
          ]
        },
        {
          title: 'Features',
          content: [
            { text: '• Backend in <strong>Python\'s Flask</strong> framework. Learned how to write my own <strong>API</strong> for the first time.', type: '' },
            { text: '• Frontend in vanilla <strong>HTML</strong> + <strong>CSS</strong> + <strong>JS</strong>. I think you can probably tell that I did not try very hard to make it look good because I already had frontend experience.', type: '' },
            { text: '• <strong>Git</strong> for version control. Learned how to use <strong>CI/CD</strong>.', type: '' },
            { text: '• User authentication and session management with <strong>Flask-Login</strong>, <strong>Flask-Session</strong>, and <strong>Werkzeug</strong>.', type: '' },
            { text: '• <strong>SQLite</strong> database for development, <strong>PostgresSQL</strong> on <strong>AWS RDS</strong> for production. I use it to store user information like name, preferences, etc.', type: '' },
            { text: '• <strong>Celery</strong> tasks that automates daily stock data retrieval from <strong>yfinance</strong> and stores it in a <strong>Redis</strong> cache.', type: '' },
            { text: '• <strong>OpenAI API</strong> for summarizing stock performance, <strong>Clearbit API</strong> for scraping company metadata, and <strong>Yahoo Finance JSON API</strong> for stock performance data.', type: '' },
            { text: '• <strong>NumPy</strong> for numerical calculations + <strong>Pandas</strong> for cleaning, filtering, and structuring the data I found in huge <strong>CSVs</strong>.', type: '' },
            { text: '• <strong>AWS EC2</strong> with <strong>Ubuntu</strong> for deployment. <strong>Nginx</strong> + <strong>Gunicorn</strong> stack.', type: '' }
          ]
        },
        {
          title: 'Gallery',
          content: [
            { 
              src: '/assets/finoria1.png', 
              caption: 'Finoria\'s homepage.' 
            },
            { 
              src: '/assets/finoria2.png', 
              caption: 'The <strong>OpenAI</strong>-generated response if you ask it a question about a certain stock. The dashboard, which recommends stocks in accordance with user preferences, is in the background.' 
            },
            { 
              src: '/assets/finoria3.jpg', 
              caption: 'The form that allows users to define their preferences. I used <strong>JS</strong> on this page to make responsive checkboxes and a slider.' 
            },
            { 
              src: '/assets/finoria4.jpg', 
              caption: 'Introductory screen for users who just verified their email. Users are also free to use "Forgot my Password."' 
            }
          ]
        }
      ]
    },
    ONE_WAY_OUT: {
      NAME: 'One Way Out',
      DATE: '01/24 - 03/24',
      TYPE: 'Text-Based RPG',
      TITLE: 'One Way Out - Text-Based RPG',
      SUBTITLE: '',
      IMAGE: '',
      SECTIONS: [
        {
          title: 'Project Description',
          content: [
            { text: 'One Way Out is a text-based <strong>RPG</strong> written in <strong>C++</strong> and played entirely through the terminal. Assuming the role of <strong>Scrum Master</strong>, I worked in a team of 5 to create it as part of a class project. During this project, we also learned about <strong>test-driven development</strong>, writing <strong>test suites</strong>, <strong>Agile</strong> methodologies, and collaborating to make detailed <strong>UML</strong> diagrams. For fun, I later created a more advanced <strong>Java</strong> version of the game on my own.', type: '' }
          ]
        },
        {
          title: 'Download & Play',
          content: [
            { text: 'Instead of reading a feature list, feel free to download and play it for yourself!', type: '' },
            { 
              type: 'download',
              text: 'Download One Way Out',
              file: '/OneWayOut.exe',
              caption: 'Just run the .exe and play in your console. I promise it\'s not a virus!'
            },
            { 
              type: 'image',
              src: '/assets/uml.png',
              caption: '<strong>UML</strong> Diagram.'
            }
          ]
        }
      ]
    }
  },

  // experience data
  EXPERIENCE: {
    INTERDEPENDENT: {
      COMPANY: 'INTERDEPENDENT',
      TIMESPAN: '01/25 - 12/25',
      DESCRIPTION: 'Virtual Movie Studio',
      ROLE: 'SWE Intern',
      TITLE: 'INTERDEPENDENT - Virtual Movie Studio',
      SUBTITLE: 'Software Engineering Intern (01/25 - 12/25)',
      IMAGE: '/assets/interdependent-screenshot.png',
      SECTIONS: {
        COMPANY_OVERVIEW: {
          TITLE: 'Company Overview',
          CONTENT: [
            { text: 'INTERDEPENDENT is a digital film studio that runs the entire filmmaking process online. We use AI tools to discover, test, and shape scripts, release trailers for real-time audience feedback, and manage everything from budgets to talent payments. It\'s where data meets storytelling, making film production more open and collaborative than traditional Hollywood.', type: '' }
          ]
        },
        CONTRIBUTION_SUMMARY: {
          TITLE: 'Contribution Summary',
          CONTENT: [
            { text: '<strong>(1).</strong> Built and deployed The Mailroom, a full-stack script reading platform that leverages <strong>React</strong>, <strong>Typescript</strong>, <strong>SQL</strong>, <strong>Supabase</strong>, and <strong>Vercel</strong>. It includes features like a real-time community forum, a recommendation algorithm, a script feedback system, and much more.', type: '' },
            { text: '<strong>(2).</strong> Developed a site for INTERDEPENDENT\'s Official Operating Agreement using <strong>React</strong>, <strong>PostgreSQL</strong>, and <strong>AWS EC2</strong>. The site has features like version control, an AI chatbot, and mass translation. It also acts as the entry point for our signing flow, which functions like DocuSign.', type: '' },
            { text: '<strong>(3).</strong> Designed a custom authentication microservice with <strong>Node.js</strong> and <strong>Stripe Identity</strong> that could be used across multiple websites and platforms within INTERDEPENDENT\'s system. Our team is also working on <strong>OAuth2</strong> and Face Recognition.', type: '' },
            { text: '<strong>(4).</strong> Built an automated screenplay evaluation pipeline with <strong>Flask</strong>, <strong>Miro webhooks</strong>, and <strong>OpenAI API</strong>, leveraging <strong>LLMs</strong> for JSON scoring, in-app dashboards, and <strong>SMTP</strong> report delivery for 5,000+ submissions.', type: '' },
            { text: '<strong>(5).</strong> Prototyping an interactive video shopping platform with <strong>Next.js</strong>, <strong>React</strong>, <strong>TypeScript</strong>, <strong>Prisma</strong>, and <strong>PostgreSQL</strong>, using <strong>Redis</strong> caching for performance and <strong>Mux</strong> + <strong>Shaka Player</strong> for streaming. Interactive overlays are built with <strong>Framer Motion</strong> and <strong>Tailwind CSS</strong>, managed by a state-machine architecture with a face-avoidance algorithm. The system also includes <strong>Sentry</strong> monitoring and API caching for scalability.', type: '' }
          ],
          IMAGES: [
            { src: '/assets/mailroom-screenshot-1.png', alt: 'Mailroom Platform Screenshot 1' },
            { src: '/assets/mailroom-screenshot-2.png', alt: 'Mailroom Platform Screenshot 2' },
            { src: '/assets/operating-agreement-screenshot-1.png', alt: 'Operating Agreement Site Screenshot 1' },
            { src: '/assets/operating-agreement-screenshot-2.png', alt: 'Operating Agreement Site Screenshot 2' },
            { src: '/assets/auth-microservice-screenshot-1.png', alt: 'Authentication Microservice Screenshot 1' },
            { src: '/assets/auth-microservice-screenshot-2.png', alt: 'Authentication Microservice Screenshot 2' },
            { src: '/assets/screenplay-pipeline-screenshot-1.png', alt: 'Screenplay Evaluation Pipeline Screenshot 1' },
            { src: '/assets/screenplay-pipeline-screenshot-2.png', alt: 'Screenplay Evaluation Pipeline Screenshot 2' },
            { src: '/assets/video-shopping-screenshot-1.png', alt: 'Interactive Video Shopping Platform Screenshot 1' },
            { src: '/assets/video-shopping-screenshot-2.png', alt: 'Interactive Video Shopping Platform Screenshot 2' }
          ]
        },
        SAMPLES: {
          TITLE: 'Gallery',
          SLIDESHOW: {
            IMAGES: [
              { src: '/assets/MailroomDashboard.png', caption: 'The Mailroom\'s dashboard. I helped design a recommendation algorithm which queries user reading history, bookmarks, and reactions to determine what kinds of scripts to show. The algorithm also performs NLP analysis on the user\'s forum discussions to deduce sentiment.' },
              { src: '/assets/MailroomForum.png', caption: 'A forum for a specific script in The Mailroom. I created a system where users can create and delete threads, converse about their favorite scenes, report problematic messages, and more. They can even record minute-long voice memos, which is transcribed using <strong>OpenAI\'s Whisper API</strong>.' },
              { src: '/assets/MailroomReader.png', caption: 'The Mailroom\'s script reader interface, where users can read scripts, react to specific pages, and leave bookmarks.' },
              { src: '/assets/OPagreement.png', caption: 'The INTERDEPENDENT Operating Agreement site, complete with version control, a signing flow, and an interface for signatories to ask questions.' },
              { src: '/assets/casey1.png', caption: 'The frontend for our automated script pre-screening pipeline. I co-engineered a system where we use <strong>Miro webhooks</strong> to detect/store submitted pdfs, <strong>OpenAI API</strong> to screen them, and a <strong>Flask</strong> server hosted on an <strong>EC2</strong> instance for the intermediary business logic.' },
              { src: '/assets/casey2.png', caption: 'The email that gets sent out to scriptwriters who submit screenplays for review. It\'s the end result of my <strong>Flask</strong> pipeline, which receives <strong>LLM JSON</strong>, renders it into HTML with <strong>Jinja2</strong> and CSS styling, converts the result to PDF through <strong>pdfkit/wkhtmltopdf</strong>, and emails it via <strong>MailChimp SMTP</strong>. Over 5,000 submissions so far, with hundreds reaching manual review and beyond.' },
              { src: '/assets/TheTeam1.png', caption: 'I have so much more to share, but have to keep it confidential for now. Instead, here\'s a picture of some of our team members hard at work during a sprint in Pennsylvania! It was overall a very productive trip for us.' }
            ]
          }
        }
      }
    },
    QUEST_2_RECOVERY: {
      COMPANY: 'Quest 2 Recovery',
      TIMESPAN: '12/25 - 01/26',
      DESCRIPTION: 'Medical Billing',
      ROLE: 'Contract Software Engineer',
      TITLE: 'Quest 2 Recovery - Medical Billing',
      SUBTITLE: 'Contract Software Engineer (12/25 - 01/26)',
      IMAGE: '',
      SECTIONS: {
        COMPANY_OVERVIEW: {
          TITLE: 'Company Overview',
          CONTENT: [
            { text: 'Quest 2 Recovery reimagined what residential rehabilitation should feel like. They provide onsite medical care across several facilities in the Lancaster, CA area.', type: '' }
          ]
        },
        CONTRIBUTION_SUMMARY: {
          TITLE: 'Contribution Summary',
          CONTENT: [
            { text: 'I was contracted by the Executive Director of Quest 2 Recovery to conceptualize and execute the automation of repetititive medical insurance billing phone calls. To engineer this system, I used a <strong>Java</strong> / <strong>Spring</strong> backend hosted on <strong>Azure App Service</strong> and made use of external <strong>APIs</strong> from <strong>Twilio</strong> and <strong>OpenAI</strong>. I also built a data visualization tool using <strong>Azure Functions</strong> to pull from a <strong>MongoDB</strong> (<strong>NoSQL</strong>) database.', type: '' },
            { text: 'In just a month, my efforts resulted in the business saving money at a rate of over $70,000 per year.', type: '' }
          ]
        }
      }
    },
    VISA: {
      COMPANY: 'Visa',
      TIMESPAN: '05/26 - 08/26',
      DESCRIPTION: 'Payment Technology',
      ROLE: 'Software Engineer Intern',
      TITLE: 'Visa - Payment Technology',
      SUBTITLE: 'Software Engineer Intern (05/26 - 08/26)',
      IMAGE: '',
      SECTIONS: {
        COMPANY_OVERVIEW: {
          TITLE: 'Company Overview',
          CONTENT: [
            { text: 'Visa Inc. is a global leader in digital payments, connecting consumers, businesses, banks, and governments through secure and reliable transaction infrastructure. The company powers billions of transactions each year across more than 200 countries and territories, enabling commerce at both local and international scale. Visa is known for combining resilient payment networks with innovation in fraud prevention, data insights, and modern financial technology.', type: '' }
          ]
        },
        CONTRIBUTION_SUMMARY: {
          TITLE: 'Contribution Summary',
          CONTENT: [
            { text: 'This internship is still ongoing, and I am genuinely enjoying the work and learning experience so far, so I do not have too much I can share yet.', type: '' },
            { text: '• Empower transaction analysis by visualizing 60+ routes for 40+ engineers using D3.js, Python, and FastAPI.', type: '' },
            { text: '• Spearhead dashboard support for 8+ locales using Hugging Face, i18next, and Google Cloud Translation.', type: '' }
          ]
        }
      }
    },
    IGNITE: {
      COMPANY: 'Ignite Roleplay',
      TIMESPAN: '11/22 - 06/24',
      DESCRIPTION: 'Multiplayer Gaming Server',
      ROLE: 'Co-Founder & Project Manager',
      TITLE: 'Ignite Roleplay - Multiplayer Gaming Server',
      SUBTITLE: 'Co-Founder & Project Manager (11/22 - 06/24)',
      IMAGE: '/assets/ignite-screenshot.png',
      SECTIONS: {
        COMPANY_OVERVIEW: {
          TITLE: 'Company Overview',
          CONTENT: [
            { text: 'Ignite Roleplay was a GTA V modification server built on <strong>FiveM</strong>, a scripting framework that leverages server/client APIs with <strong>Lua</strong>, <strong>JS</strong>, and <strong>C#</strong> to extend game logic and systems. The project involved running a high-traffic <strong>SQL</strong> database, tuning performance for peak player loads, and rolling out custom resources without downtime. Over a year and a half, what began as a hobby evolved into a successful venture, connecting us with thousands of users around the world. We were proud to have empowered them to express themselves with their own virtual <a href="https://igniteroleplay.fandom.com/wiki/Category:1.0/Characters" target="_blank" rel="noopener noreferrer">"characters"</a>. After quite the roller coaster, we eventually sold the Ignite brand and all of its resources to a new team.', type: '' },
            { text: 'At Ignite\'s peak, the brand boasted the following accolades:', type: '' },
            { text: '<div class="accolades-row"><span>• 10,000+ unique international users</span><span>• 60,000+ Twitch viewers </span><span>• 130,000+ TikTok followers</span></div>', type: 'accolades' },
            { text: '<div class="accolades-row"><span>• 8,000+ Discord Members</span><span>• An average of 175/175 concurrent players, queue of 30+</span><span>• Enough revenue to get me through college ;)</span></div>', type: 'accolades' }
          ]
        },
        SAMPLES: {
          TITLE: 'Gallery',
          SLIDESHOW: {
            IMAGES: [
              { 
                type: 'youtube',
                thumbnail: '/assets/youtube-thumbnail.png',
                embedUrl: 'https://www.youtube.com/embed/DXdttXJswIQ?si=a8r9lEtlUXDGIdCk',
                caption: 'Our launch trailer. It\'s purely cinematic. We obviously had no help from professional editors because it was just a hobby project at this time!'
              },
              { 
                type: 'youtube',
                thumbnail: '/assets/youtube-thumbnail-2.png',
                embedUrl: 'https://www.youtube.com/embed/JoWHU90evdA?si=Mx18G9fFNzsf0YUt&start=250',
                caption: 'The gameplay trailer for our first major update. This particular timestamp showcases a newspaper creation, distribution, and purchasing system, which I developed. You can also briefly see the Polaroid system, which we enhanced to fit the 1980s theme with HTML, CSS, and JS. Almost none of the features showcased in this trailer are in the base game.'
              },
              { 
                type: 'youtube',
                thumbnail: '/assets/youtube-thumbnail-3.png',
                embedUrl: 'https://www.youtube.com/embed/G-MLSWF-KyI?si=YCZVYXFV68CKFkZD&start=676',
                caption: 'A video by YouTuber Jameskii made entirely with gameplay on Ignite Roleplay. It showcases several features that I personally built. This  timestamp (11:17 - 11:57) briefly shows my Postal Service system, which allowed players to write letters, store letters, and save contacts. At our peak, this feature alone was responsible for over approximately 500 database reads and writes a day. The video is currently sitting at 1.3M views.' 
              },
              { 
                type: 'youtube',
                thumbnail: '/assets/youtube-thumbnail-4.png',
                embedUrl: 'https://www.youtube.com/embed/Sa8JbkpVU_c?si=8Fzhnae04gmZQ12q&start=15852',
                caption: 'An archived stream from popular Twitch streamer Penta (364k followers). At this timestamp (4:24:14), his character enters a convenience store, during which many features I worked on are showcased: the health, armor, hunger, thirst, and stamina bars, inventory, and buying coffee with cash.'
              },
              { 
                type: 'youtube',
                thumbnail: '/assets/youtube-thumbnail-5.png',
                embedUrl: 'https://www.youtube.com/embed/ox5xJ9_E7Jg?si=bmnDRUGM3hyBnJgF',
                caption: 'A popular streamer watching one of our bi-weekly "Community Meetings," where we\'d take input from users and make decisions on which direction to steer development. This one surpassed 300 audience members, who would come up and ask questions, and thousands more passive spectators watching via Twitch. I am one of the panelists.'
              },
              { 
                src: '/assets/cosanostra2.png', 
                caption: 'A screenshot of some players in-game. Their group is just one example of <a href="https://igniteroleplay.fandom.com/wiki/Category:1.0/Characters" target="_blank" rel="noopener noreferrer">HUNDREDS of sub-communities and "characters"</a> that were formed as a result of our platform. I always found it really cool that we were able to create an immersive environment for all of those people to express themselves and make new friends.' 
              }
            ]
          }
        },
        CONTRIBUTION_SUMMARY: {
          TITLE: 'Contribution Summary',
          CONTENT: [
            { text: '<strong>(1).</strong> Wrote custom <strong>Lua</strong> resources from scratch, leveraging server/client APIs to extend gameplay mechanics with economy systems, player utilities, quality-of-life features, and much more. We had immense (and often unreasonable) public pressure on us to deliver high quality features as fast as possible.', type: '' },
            { text: '<strong>(2).</strong> Managed a 7-person junior development team using <strong>Agile</strong> methods and <strong>GitHub</strong>. Because the team was made up almost entirely of community volunteers from around the world, I couldn\'t assign shifts or set strict schedules. We instead focused on building an organized, flexible workflow that kept everyone aligned while still giving them the freedom to contribute on their own time.', type: '' },
            { text: '<strong>(3).</strong> Removed <strong>POST</strong> forgery attack surface by validating session tokens and enforcing <strong>CSRF</strong> protection. Many tech-savvy players tried to send their own payloads to our resources in an attempt to exploit in-game systems like currency, inventory, etc.', type: '' },
            { text: '<strong>(4).</strong> Managed a high-traffic <strong>SQL</strong> database through <strong>phpMyAdmin</strong> that had supported thousands of player interactions in real time. Optimized queries to keep players immersed with fast, stable, and bug-free feedback.', type: '' },
            { text: '<strong>(5).</strong> Customized the user experience of both existing and newly developed resources using <strong>HTML</strong>, <strong>CSS</strong>, and <strong>JavaScript</strong>. I emphasized aligning the design with the server\'s 1980s theme for the purposes of immersion and player engagement.', type: '' },
            { text: '<strong>(6).</strong> Built a ticketing bot using <strong>Discord.js</strong>, containerized it with <strong>Docker</strong>, and deployed it using <strong>Railway</strong>. This bot processed somewhere over 2,000 tickets, ranging from player reports, bug reports, donations/purchases, staff applications, and more.', type: '' },
            { text: '<strong>(7).</strong> Somehow survived the pressure of constantly being talked about and watched by thousands of people across Twitch, Reddit, Discord, etc.', type: '' }
          ],
          IMAGES: [
            { src: '/assets/ignite-screenshot-1.png', alt: 'Ignite Roleplay Server Screenshot 1' },
            { src: '/assets/ignite-screenshot-2.png', alt: 'Ignite Roleplay Server Screenshot 2' },
            { src: '/assets/ignite-screenshot-3.png', alt: 'Ignite Roleplay Server Screenshot 3' },
            { src: '/assets/ignite-screenshot-4.png', alt: 'Ignite Roleplay Server Screenshot 4' },
            { src: '/assets/ignite-screenshot-5.png', alt: 'Ignite Roleplay Server Screenshot 5' }
          ]
        },
        PERSONAL_NOTES: {
          TITLE: 'Additional Notes (<span class="bonus-text">just a bonus!!</span>)',
          CONTENT: [
            { text: '• I am not permitted to share a vast vast majority of the code for this project because almost all of our resources were sold to new owners as an exclusivity deal. Putting the source code out there would allow others to replicate them.', type: '' },
            { text: '• To avoid harassment from toxic players (there were plenty), I used a fake name during my time at Ignite. My co-founder, who took more of a public spotlight, was unfortunately targeted.', type: '' },
            { text: '• At our absolute peak, we were the #1 most watched GTA RP server in the world, surpassing even NoPixel, which is notoriously the most popular. NoPixel\'s owner addressed our popularity several times in a series of livestreams.', type: '' },
            { text: '• Our success was virtually a total accident. Neither of us intended for it to become what it did.', type: '' },
            { text: '• We had a team of over 20 staff members, consisting of both paid developers and volunteers, all with their own responsibilities. Their roles ranged from graphic design, to community management, to content moderation, to software development. A few of our teammates worked for companies like Oracle, Blizzard, and Ubisoft.', type: '' },
            { text: '• Ignite had its fair share of controversies, which primarily stemmed from content creators not receiving special treatment, and henceforth "unleashing" their communities upon us. Over the course of about a year, we had seen it all- lies about our team, blackmail, harassment, etc. When I realized that I had lost the time to care for my own mental health, we decided to stop exhausting ourselves, which eventually led to the sale of the brand.', type: '' }
          ]
        }
      }
    },
    UC_RIVERSIDE: {
      COMPANY: 'UC Riverside',
      TIMESPAN: '04/24 - Present',
      DESCRIPTION: 'University',
      ROLE: 'Course Assistant',
      TITLE: 'UC Riverside - CS100 Course Assistant',
      SUBTITLE: 'Computer Science and Engineering Department',
      IMAGE: '/assets/ucr-screenshot.png',
      SECTIONS: {
        COMPANY_OVERVIEW: {
          TITLE: 'Company Overview',
          CONTENT: [
            { text: 'It\'s my school! UCR is a leading public research university with a truly enjoyable Computer Science program. I\'ve made plenty of friends during my time here and am proud to be a Highlander.', type: '' },
            { text: '', type: '' },
            { text: 'I am a Course Assistant for CS100, a Software Construction course and the first upper-division class required of CS students. It teaches principles like:', type: '' },
            { text: '<div class="accolades-row"><span>• <strong>OOP</strong> in <strong>C++</strong></span><span>• <strong>Data Structures</strong></span><span>• <strong>Scrum</strong></span></div>', type: 'accolades' },
            { text: '<div class="accolades-row"><span>• <strong>Git</strong></span><span>• <strong>Test-Driven Development</strong></span><span>• <strong>CI/CD</strong></span></div>', type: 'accolades' },
            { text: '<div class="accolades-row"><span>• <strong>Valgrind</strong></span><span>• <strong>Code Coverage Testing</strong></span><span>• <strong>Test Suites (GoogleTest)</strong></span></div>', type: 'accolades' }
          ]
        },
        CONTRIBUTION_SUMMARY: {
          TITLE: 'Contribution Summary',
          CONTENT: [
            { text: '<strong>(1).</strong> Graded lab demonstrations from 200+ students.', type: '' },
            { text: '<strong>(2).</strong> Helped all students in my sections debug and understand their <strong>C++</strong> code without expressly giving them the answer (this is not technically part of my job but I can\'t help myself sometimes).', type: '' },
            { text: '<strong>(3).</strong> Proctored and graded exams.', type: '' },
            { text: '<strong>(4).</strong> Took part in weekly meetings for curriculum relevance and team coordination.', type: '' }
          ]
        },
        PERSONAL_NOTES: {
          TITLE: 'Additional Notes (<span class="bonus-text">just a bonus!!</span>)',
          CONTENT: [
            { text: '• I got this job because the person who was grading my final lab for CS100 liked it enough to refer me on the spot.', type: '' }
          ]
        }
      }
    }
  },

  // desktop icons
  DESKTOP_ICONS: {
    ABOUT: "About Avo",
    ENVIRONMENTS: "Environments", 
    REPOSITORIES: "Repositories",
    SKILLS: "Resume",
    PARTY: "Party",
    PROJECTS: "Projects",
    EXPERIENCE: "Experience",
    EDUCATION: "Education"
  },

  // social links
  SOCIAL: {
    LINKEDIN: "https://www.linkedin.com/in/avo-karamusyan/",
    GITHUB: "https://github.com/akaFM",
    EMAIL: "avokaramusyan@gmail.com"
  }
};

export default TEXT;
